export const mapSecondsToMode = (seconds: number) => {
    if (seconds < 60) {
        return `${seconds}S`;
    }

    return `${seconds / 60}M`;
};
